(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["preorder-notification"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('preorder-notification-block')) {
    class PreorderNotificationBlock extends HTMLElement {
      connectedCallback() {
        this.messages = {};
        try {
          this.messages = JSON.parse(this.querySelector('[data-preorder-messages]')?.textContent || '{}');
        } catch (e) {
          /* ignore */
        }

        this.closeButton = this.querySelector('[data-preorder-close]');
        this.closeButton?.addEventListener('click', this.#dismiss);
        this.#applyDismissed();

        // The section re-renders on variant change; keep a dismissed notice hidden for the same message.
        this.observer = new MutationObserver(() => this.#applyDismissed());
        this.observer.observe(this, {
          childList: true,
          characterData: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['hidden'],
        });

        this.#listenForVariantChange();
      }

      disconnectedCallback() {
        this.closeButton?.removeEventListener('click', this.#dismiss);
        this.observer?.disconnect();
        this.observer = null;
        this.section?.removeEventListener('change', this.#onPickerChange);
        this.section?.removeEventListener(this.productSelectEvent, this.#onProductSelect);
        document.removeEventListener('variant:update', this.#onVariantEvent);
        document.removeEventListener('variant:selected', this.#onVariantEvent);
        clearTimeout(this.changeTimer);
      }

      /* ---------- variant changes ---------- */

      #listenForVariantChange() {
        this.section = this.closest('.shopify-section');

        // Shopify's standard product-select event, the same one the gallery and sqft blocks use.
        this.productSelectEvent = 'product:select';
        import('https://cdn.shopify.com/storefront/standard-events.js')
          .then((mod) => {
            if (!mod?.StandardEvents?.productSelect || !this.isConnected) return;
            this.productSelectEvent = mod.StandardEvents.productSelect;
            this.section?.addEventListener(this.productSelectEvent, this.#onProductSelect);
          })
          .catch(() => {});

        // Theme variant events, and a picker change followed by a URL check as a fallback.
        document.addEventListener('variant:update', this.#onVariantEvent);
        document.addEventListener('variant:selected', this.#onVariantEvent);
        this.section?.addEventListener('change', this.#onPickerChange);
      }

      #onProductSelect = (event) => {
        if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
        this.#update(event.detail?.variantId);
      };

      #onVariantEvent = (event) => {
        const detail = event.detail || {};
        this.#update(detail.resource?.id ?? detail.variantId ?? detail.variant?.id);
      };

      #onPickerChange = (event) => {
        if (!(event.target instanceof Element) || !event.target.closest('variant-picker')) return;
        // The picker writes ?variant= to the URL as it updates, so check it shortly after the change.
        clearTimeout(this.changeTimer);
        this.changeTimer = setTimeout(() => this.#update(), 50);
        setTimeout(() => this.#update(), 500);
      };

      #update(variantId) {
        const id = String(variantId || new URL(window.location.href).searchParams.get('variant') || '');
        if (!id || id === this.currentVariantId) return;
        this.currentVariantId = id;

        const html = (this.messages[id] || '').trim();
        const target = this.querySelector('[data-preorder-message]');
        if (target && target.innerHTML.trim() !== html) target.innerHTML = html;
        this.style.display = html ? '' : 'none';
      }

      /* ---------- dismiss ---------- */

      get #storageKey() {
        return `preorder-dismissed-${this.dataset.productId}`;
      }

      get #message() {
        return (this.querySelector('[data-preorder-message]')?.textContent || '').trim();
      }

      #dismiss = () => {
        this.hidden = true;
        try {
          sessionStorage.setItem(this.#storageKey, this.#message);
        } catch (e) {
          /* storage unavailable, the notice still hides for this page view */
        }
      };

      #applyDismissed() {
        let dismissed = false;
        try {
          const saved = sessionStorage.getItem(this.#storageKey);
          dismissed = saved !== null && saved === this.#message;
        } catch (e) {
          /* ignore */
        }
        if (dismissed && !this.hidden) this.hidden = true;
        if (!dismissed && this.hidden) this.hidden = false;
      }
    }

    customElements.define('preorder-notification-block', PreorderNotificationBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
